"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export namespace gs_browser_http {
function GET(url, options) {
    const p = new Promise((resolve, reject) => {
        const ajax = new XMLHttpRequest();
        ajax.open('GET', url);
        if (options) {
            if (options.headers) {
                Object.keys(options.headers).forEach(key => {
                    if (options.headers) {
                        ajax.setRequestHeader(key, options.headers[key]);
                    }
                });
            }
        }
        ajax.send();
        ajax.onreadystatechange = (event) => {
            if (ajax.readyState === 4 && ajax.status === 200) {
                const contentType = ajax.getResponseHeader('content-type') || '';
                resolve({ 'contentType': contentType, data: ajax.responseText });
            }
            if (ajax.readyState === 4 && ajax.status !== 200) {
                const contentType = ajax.getResponseHeader('content-type') || '';
                resolve({ 'contentType': contentType, data: '{"status":' + ajax.status + '}' });
            }
        };
    });
    return p;
}
exports.GET = GET;
function POST(url, data, options) {
    const p = new Promise((resolve, reject) => {
        const ajax = new XMLHttpRequest();
        ajax.open('POST', url);
        if (options) {
            if (options.headers) {
                Object.keys(options.headers).forEach(key => {
                    if (options.headers) {
                        ajax.setRequestHeader(key, options.headers[key]);
                    }
                });
            }
        }
        ajax.send(data);
        ajax.onreadystatechange = (event) => {
            if (ajax.readyState === 4 && ajax.status === 200) {
                const contentType = ajax.getResponseHeader('content-type') || '';
                resolve({ 'contentType': contentType, data: ajax.responseText });
            }
            if (ajax.readyState === 4 && ajax.status !== 200) {
                const contentType = ajax.getResponseHeader('content-type') || '';
                resolve({ 'contentType': contentType, data: '{"status":' + ajax.status + '}' });
            }
        };
    });
    return p;
}
exports.POST = POST;
// }
